export default "__VITE_ASSET__ca8e2d4e__"